export default __webpack_public_path__ + "static/media/powerball_banner.e64688c4.png";